import { get, post, remove } from 'api.vanilla.service';
import { formatErrorMessage } from 'api/helpers';
import { set as setFeedback } from 'feedback.vanilla.service.js';

import phrases from './productRecommendations.phrases';

/**
 * @function fetchProductRecommendation
 * @description Fetch all product recommendations
 * @param {object} state
 */
export function fetchProductRecommendation(state) {
	// Set params and filter
	const params = {
		limit: state.limit,
		sort: state.sort,
		offset: state.offset,
		filter: state.filter
	};

	return get('/pos/product_recommendations', params, null, state.headers)
		.then(res => {
			return res;
		})
		.catch(err => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
		});
}

/**
 * @function editProductRecommendation
 * @description edits addon recommendation
 */
export function editProductRecommendation(data) {
	return post(`/pos/product_recommendations/${data.id}`, data)
		.then(res => {
			setFeedback(phrases.PRODUCT_RECOMMENDATION_EDITED, 1);
			return res;
		})
		.catch(err => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
			return Promise.reject;
		});
}

/**
 * @function addProductRecommendation
 * @description adds addon recommendation
 */
export function addProductRecommendation(data) {
	return post('/pos/product_recommendations', data)
		.then(res => {
			setFeedback(phrases.PRODUCT_RECOMMENDATION_ADDED, 1);
			return res;
		})
		.catch(err => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
		});
}

/**
 * @function deleteProductRecommendation
 * @description deletes addon recommendations
 */
export function deleteProductRecommendation(productId) {
	return remove(`/pos/product_recommendations/${productId}`)
		.then(res => {
			setFeedback(phrases.PRODUCT_RECOMMENDATION_DELETED, 1);
			return res;
		})
		.catch(err => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
			throw err;
		});
}
